export default "__VITE_PUBLIC_ASSET__b987902b__"